import { FragmentComponent } from "./FragmentComponent";
import { SubconfigurationNavigationButtons } from "./SubconfigurationNavigationButtons";
import { SubconfigurationNavigationHorizontal } from "./SubconfigurationNavigationHorizontal";
import { SubconfigurationNavigationControl, SubconfigurationNavigationOrientation, SubconfigurationNavigationSecondaryControl, } from "./SubconfigurationNavigationProps";
import { SubconfigurationNavigationVertical } from "./SubconfigurationNavigationVertical";
import { SubconfigurationStepperNavigation } from "./SubconfigurationStepperNavigation";
import { SubconfigurationTabsNavigation } from "./SubconfigurationTabsNavigation";
/**
 * Components for the main navigation, i.e. tabs or stepper
 */
const NavigationComponents = {
    [SubconfigurationNavigationControl.Tabs]: SubconfigurationTabsNavigation,
    [SubconfigurationNavigationControl.Stepper]: SubconfigurationStepperNavigation,
    [SubconfigurationNavigationControl.None]: FragmentComponent,
};
/**
 * Components for the secondary navigation, i.e. reset, next, previous buttons
 */
const SecondaryNavigationComponents = {
    [SubconfigurationNavigationSecondaryControl.Buttons]: SubconfigurationNavigationButtons,
    [SubconfigurationNavigationSecondaryControl.None]: FragmentComponent,
};
/**
 * Components for alignment of the navigation and content
 */
const AlignmentComponents = {
    [SubconfigurationNavigationOrientation.Vertical]: SubconfigurationNavigationVertical,
    [SubconfigurationNavigationOrientation.Horizontal]: SubconfigurationNavigationHorizontal,
};
/**
 * Components for the content area
 */
const ContentComponents = {
    FallbackUi: FragmentComponent,
    LoadingIndicator: FragmentComponent,
};
export const SubconfigurationNavigationComponents = {
    NavigationComponents,
    SecondaryNavigationComponents,
    AlignmentComponents,
    ContentComponents,
};
//# sourceMappingURL=SubconfigurationNavigationComponents.js.map